import { render, staticRenderFns } from "./FuncionarioEstatistica.vue?vue&type=template&id=2fcf8a8e&"
import script from "./FuncionarioEstatistica.vue?vue&type=script&lang=js&"
export * from "./FuncionarioEstatistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports